<template>
  <div class="advice3-wrap">
    <main class="screen" role="main">

      <div class="header">
        <button
          type="button"
          class="back-button"
          @click="goBack"
          aria-label="Zurück"
        >←</button>
      </div>

      <span class="badge">Für dich ausgewählt</span>
      <h1 class="title">Rezepte und Ideen</h1>
      <p class="subtitle">Basierend auf deinem Quiz schlagen wir Rezepte vor, die deine Lücken füllen.</p>

      <div class="filters">
        <button
          v-for="f in filters"
          :key="f.id"
          type="button"
          class="filter-chip"
          :class="{ active: activeFilter === f.id }"
          @click="activeFilter = f.id"
        >{{ f.label }}</button>
      </div>

      <div class="recipe-grid">
        <button
          v-for="r in visibleRecipes"
          :key="r.id"
          type="button"
          class="recipe-card"
        >
          <div class="recipe-emoji" aria-hidden="true">{{ r.emoji }}</div>
          <p class="recipe-name">{{ r.name }}</p>
          <div class="recipe-meta">
            <span>⏱ {{ r.minutes }} Min.</span>
            <span>👤 {{ r.serves }}</span>
          </div>
          <span class="recipe-tag">{{ r.tag }}</span>
        </button>
      </div>

      <p v-if="visibleRecipes.length === 0" class="empty-state">
        Keine Rezepte für diesen Filter. Wähle einen anderen.
      </p>

      <p class="placeholder-note">Beispieltexte. Die finalen Rezepte werden vom Ernährungsteam erstellt.</p>

    </main>
  </div>
</template>

<script>
export default {
  name: 'Advice3',
  data() {
    return {
      activeFilter: 'all',
      filters: [
        { id: 'all', label: 'Alle' },
        { id: 'huelsen', label: '🌱 Hülsenfrüchte' },
        { id: 'vollkorn', label: '🌾 Vollkorn' },
        { id: 'fisch', label: '🐟 Fisch' },
        { id: 'schnell', label: '⏱ Schnell' },
      ],
      recipes: [
        { id: 'linsensalat', emoji: '🥗', name: 'Linsensalat mit Feta', minutes: 20, serves: 4, tag: '🌱 Empfohlen', tags: ['huelsen'] },
        { id: 'curry', emoji: '🍲', name: 'Kichererbsen-Curry', minutes: 25, serves: 4, tag: '🌱 Empfohlen', tags: ['huelsen'] },
        { id: 'birchermuesli', emoji: '🥣', name: 'Hafer-Birchermüesli', minutes: 5, serves: 1, tag: '🌾 Empfohlen', tags: ['vollkorn', 'schnell'] },
        { id: 'lachs', emoji: '🐟', name: 'Lachs aus dem Ofen', minutes: 30, serves: 2, tag: '🐟 Wöchentlich', tags: ['fisch'] },
        { id: 'pasta', emoji: '🍝', name: 'Vollkorn-Pasta mit Linsen-Bolognese', minutes: 35, serves: 4, tag: '🌱🌾 Doppelt gut', tags: ['huelsen', 'vollkorn'] },
        { id: 'hummus', emoji: '🥖', name: 'Hummus selber machen', minutes: 10, serves: 6, tag: '🌱 Empfohlen', tags: ['huelsen', 'schnell'] },
      ],
    };
  },
  computed: {
    visibleRecipes() {
      if (this.activeFilter === 'all') return this.recipes;
      return this.recipes.filter(r => r.tags.includes(this.activeFilter));
    },
  },
  methods: {
    goBack() { this.$router.back(); },
  },
};
</script>

<style scoped>
.advice3-wrap {
  --color-bg-page: #f5f4ef;
  --color-bg-card: #ffffff;
  --color-bg-muted: #f1efe8;
  --color-text-primary: #2c2c2a;
  --color-text-secondary: #5f5e5a;
  --color-text-tertiary: #888780;
  --color-border: rgba(0, 0, 0, 0.15);
  --color-accent: #534AB7;
  --color-accent-light: #EEEDFE;
  --radius-md: 8px;
  --radius-lg: 12px;
  --font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  background: var(--color-bg-page);
  font-family: var(--font-sans);
  color: var(--color-text-primary);
  line-height: 1.5;
  min-height: 100%;
  padding: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
}

.advice3-wrap *,
.advice3-wrap *::before,
.advice3-wrap *::after {
  box-sizing: border-box;
}

.screen {
  width: 100%;
  max-width: 420px;
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  border: 0.5px solid var(--color-border);
  padding: 1.5rem 1.25rem;
  min-height: 600px;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.back-button {
  background: transparent;
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 20px;
  color: var(--color-text-secondary);
  line-height: 1;
}

.badge {
  display: inline-block;
  background: var(--color-accent-light);
  color: var(--color-accent);
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: var(--radius-md);
  margin-bottom: 1rem;
  letter-spacing: 0.02em;
}

.title {
  font-size: 24px;
  font-weight: 500;
  margin: 0 0 8px;
  line-height: 1.25;
}

.subtitle {
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0 0 1.5rem;
}

.filters {
  display: flex;
  gap: 6px;
  margin-bottom: 1.25rem;
  overflow-x: auto;
  padding: 4px;
  margin-left: -4px;
  margin-right: -4px;
}

.filter-chip {
  flex-shrink: 0;
  padding: 8px 12px;
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-bg-card);
  font-size: 13px;
  color: var(--color-text-secondary);
  cursor: pointer;
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.filter-chip.active {
  background: var(--color-accent);
  color: white;
  border-color: var(--color-accent);
}

.recipe-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 1rem;
}

.recipe-card {
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: 14px;
  background: var(--color-bg-card);
  cursor: pointer;
  transition: background 0.15s;
  text-align: left;
  font-family: inherit;
}

.recipe-card:hover {
  background: var(--color-bg-muted);
}

.recipe-emoji {
  font-size: 36px;
  margin-bottom: 8px;
  line-height: 1;
}

.recipe-name {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 6px;
  color: var(--color-text-primary);
  line-height: 1.3;
}

.recipe-meta {
  display: flex;
  gap: 10px;
  font-size: 11px;
  color: var(--color-text-tertiary);
}

.recipe-meta span {
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.recipe-tag {
  display: inline-block;
  font-size: 10px;
  color: var(--color-accent);
  background: var(--color-accent-light);
  padding: 2px 6px;
  border-radius: 4px;
  margin-top: 8px;
}

.empty-state {
  text-align: center;
  font-size: 13px;
  color: var(--color-text-tertiary);
  padding: 1rem 0;
  margin: 0;
}

.placeholder-note {
  font-size: 11px;
  color: var(--color-text-tertiary);
  text-align: center;
  margin-top: 1rem;
  font-style: italic;
}
</style>
